import { useMemo } from 'react';
import { InfoText } from '../../../../common/CustomTextDisplay';
import { FormSchemaConfig, FormState } from '../../types';

// ============= Component =============
export const usePaymentHoldReviewSchema = (
  formState: FormState
): FormSchemaConfig => {
  const schema = useMemo<FormSchemaConfig>(() => {
      const isEditAllowed = Array.isArray(formState.data?.userAssignedSections)
        ? (formState.data?.userAssignedSections as string[]).includes(
            'payment_hold_review'
          )
        : false;
    const isCompleted = formState.completedSections?.includes(
      'payment_hold_review'
    );

    return {
      sections: [
        {
          layout: 'single',
          isGrouped: true,
          isGroupedAccordion: false,
          sections: [
            {
              title: { text: 'Payment Hold Review' },
              layout: 'single',
              fields: [
                {
                  type: 'customComponent',
                  name: 'hold_review_warning',
                  label: '',
                  customComponent: (
                    <InfoText
                      text="Request is On Hold - Partner approval(s) are now completed.  Please submit to release from On Hold and progress to next stage."
                      size="small"
                      showIcon
                    />
                  ),
                },
                {
                  type: 'textArea',
                  name: 'hold_review_comments',
                  label: 'Additional Comments (Optional)',
                  placeholder:
                    'Add any additional comments about the hold status...',
                  disabled: isCompleted || !isEditAllowed,
                },
              ],
            },
          ],
          extras: { grouped: true, evenSpacing: true },
        },
      ],
    };
  }, [formState.completedSections, formState.data?.userAssignedSections]);

  return schema;
};
